// extracted by mini-css-extract-plugin
export default {"videoCard":"videoCard__zg6hL","videoInfo":"videoInfo__zaoVp","icon":"icon__hxUph"};